var map = {
  "./cs.json": [
    "OoH",
    [
      "ock"
    ]
  ],
  "./en.json": [
    "K6",
    [
      "8l"
    ]
  ],
  "./pl.json": [
    "HY",
    [
      "9q"
    ]
  ],
  "./ru.json": [
    "e1T",
    [
      "g8i"
    ]
  ],
  "./tr.json": [
    "Js",
    [
      "rqm"
    ]
  ],
  "./ja.json": [
    "v7W",
    [
      "pif"
    ]
  ],
  "./zh.json": [
    "NC",
    [
      "vo"
    ]
  ],
  "./pt-br.json": [
    "WB",
    [
      "wje"
    ]
  ],
  "./de.json": [
    "IFA",
    [
      "qp"
    ]
  ],
  "./es.json": [
    "rhu",
    [
      "d8y"
    ]
  ],
  "./fr.json": [
    "HJ",
    [
      "lo"
    ]
  ],
  "./it.json": [
    "B7B",
    [
      "v"
    ]
  ],
  "./ko.json": [
    "tOT",
    [
      "3q"
    ]
  ],
  "./pt.json": [
    "y2",
    [
      "4to"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "KM";
module.exports = __rspack_async_context;
